/* Green The Map · Rooms: drawer, hero video, small toggles. No data is sent anywhere. */
(function () {
  if (window.GTMRooms) return;
  window.GTMRooms = true;

  /* ---- phone drawer ---- */
  var dr = document.getElementById('GrDrawer');
  var opener = null;
  function openDrawer(btn) {
    if (!dr) return;
    opener = btn;
    dr.hidden = false;
    showRecent();
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-gr-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = dr.querySelector('.gr-dr__top button');
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!dr || dr.hidden) return;
    dr.hidden = true;
    document.body.style.overflow = '';
    document.querySelectorAll('[data-gr-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (opener) opener.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-gr-open]');
    if (o) { openDrawer(o); return; }
    if (e.target.closest('[data-gr-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && dr && !dr.hidden) {
      var f = dr.querySelectorAll('a[href],button');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* ---- recently viewed (this browser only): product pages write, the phone menu reads ---- */
  function readRecent() { try { return JSON.parse(localStorage.getItem('gtm_rv') || '[]'); } catch (e) { return []; } }
  function showRecent() {
    var box = dr && dr.querySelector('[data-gr-rv]'); if (!box) return;
    var here = location.pathname, list = readRecent().filter(function (p) { return p.u !== here; }).slice(0, 4);
    var ul = box.querySelector('ul'); ul.textContent = '';
    list.forEach(function (p) {
      var li = document.createElement('li'), a = document.createElement('a'), im = document.createElement('img'), t = document.createElement('span');
      a.href = p.u; im.src = p.i; im.alt = ''; im.loading = 'lazy'; im.width = 120; im.height = 120; t.textContent = p.t;
      a.appendChild(im); a.appendChild(t); li.appendChild(a); ul.appendChild(li);
    });
    box.hidden = !list.length;
  }
  window.GTMRecent = function (p) {
    if (!p || !p.u) return;
    var list = readRecent().filter(function (x) { return x.u !== p.u; });
    list.unshift(p);
    try { localStorage.setItem('gtm_rv', JSON.stringify(list.slice(0, 8))); } catch (e) {}
  };

  /* ---- hero video: muted loop, poster only with reduced motion or on error, pause button ---- */
  function initVideo(fr) {
    var v = fr.querySelector('video'), b = fr.querySelector('.gr-vpause');
    if (!v || fr.dataset.ready) return;
    fr.dataset.ready = '1';
    var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shown = fr.offsetParent !== null;
    v.addEventListener('error', function () { fr.classList.add('is-novideo'); });
    if (rm || !shown) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
    } else {
      if (v.preload === 'none') v.preload = 'metadata';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (b) b.addEventListener('click', function () {
      if (v.paused) { v.play(); b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Pause video'); }
      else { v.pause(); b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-label', 'Play video'); }
    });
  }
  document.querySelectorAll('[data-gr-video]').forEach(initVideo);

  /* ---- transparent header over the home hero: solid as soon as the page scrolls ---- */
  var hd = document.querySelector('.gr-hd[data-gr-over]');
  if (hd) {
    var heroes = [].slice.call(document.querySelectorAll('[data-gr-hero]'));
    var hero = heroes.filter(function (h) { return h.offsetParent !== null; })[0];
    var root = document.documentElement;
    var bar = document.querySelector('.gr-season');
    var setBar = function () { root.style.setProperty('--gr-bar-h', (bar && bar.offsetParent !== null ? bar.offsetHeight : 0) + 'px'); };
    setBar(); window.addEventListener('resize', setBar);
    if (!hero) { hd.classList.remove('is-over'); root.classList.remove('gr-has-over'); }
    else {
      root.classList.add('gr-has-over');
      var upd = function () {
        // see-through only while the page sits at the very top; solid as soon as it scrolls
        var solid = window.scrollY > 24 || (dr && !dr.hidden);
        hd.classList.toggle('is-over', !solid);
      };
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
  }

  /* ---- desktop video source for full-bleed heroes ---- */
  document.querySelectorAll('video[data-src-lg]').forEach(function (v) {
    if (window.matchMedia('(min-width: 760px)').matches) { v.src = v.dataset.srcLg; }
  });

  /* ---- cart gift toggle (gtm-gift-options): delegated so it survives cart drawer re-renders ---- */
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('.gtm-gift__check');
    if (!box) return;
    var note = box.closest('.gtm-gift').querySelector('.gtm-gift__note');
    if (note) note.hidden = !box.checked;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { Gift: box.checked ? 'Yes' : '' } }),
    });
  });

  /* ---- segmented example toggles (frequency) ---- */
  document.querySelectorAll('[data-gr-seg]').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      g.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (b.dataset.freq) document.querySelectorAll('[data-freq-out]').forEach(function (o) { o.textContent = b.dataset.freq; });
    });
  });
})();
